
export enum API_TYPES {
    LB,
    HARDCODED,
    AWS
}


export enum NET_TYPES {
    LOCAL,
    AWS
}

export class Config {
    static userPoolId: string = "user pool id";
    static clientId: string = "clientid";
    static api: {
        type: API_TYPES 
    } = {
        type: API_TYPES.HARDCODED
    }
    static net: {
        type: NET_TYPES
    } = {
        type: NET_TYPES.AWS
    }

    static url: {
        schema: string,
        host: string,
        port: string,
        stage: string
    } = {
            schema: '',
            host: '',
            port: '',
            stage: ''
        };
    // static net = {
    //     schema: "http",
    //     host: "localhost",
    //     port: "3007"
    // }
}
